<div class="pdf-container">
  @for (page of pages; track page) {
    <div>
      <canvas #pdfCanvas></canvas>
    </div>
  }
</div>
